import React, { useState, useCallback } from 'react';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/uiconfig';
import { EntryPageTemplate } from 'gw-components-platform-react';
import { Loader } from '@jutro/components';
import { useAuthentication } from 'gw-digital-auth-react';

import metadata from './EntryPage.metadata.json5';

const VIEWS = {
    logInView: 'LOG_IN_VIEW',
    forgotPasswordView: 'FORGOT_PASSWORD_VIEW'
};

const { applicationDetails } = appConfig;

function EntryPage({ location }) {
    const { isAuthInProgress } = useAuthentication();
    const [view, updateView] = useState(VIEWS.logInView);
    const { state } = location;

    const handleForgotPasswordClick = useCallback(() => {
        updateView(VIEWS.forgotPasswordView);
    }, []);

    const handleSignInClick = useCallback(() => {
        updateView(VIEWS.logInView);
    }, []);

    if (isAuthInProgress) {
        return <Loader loaded={!isAuthInProgress} />;
    }

    const overrideProps = {
        gwLoginComponent: {
            successPath: _.get(state, 'from.pathname') || '/'
        },
        logInViewContainer: {
            visible: view === VIEWS.logInView
        },
        forgotPasswordViewContainer: {
            visible: view === VIEWS.forgotPasswordView
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onForgotPasswordClick: handleForgotPasswordClick,
            onSignInClick: handleSignInClick
        }
    };

    const renderedContentFromMetadata = <MetadataContent
        uiProps={metadata.pageContent}
        overrideProps={overrideProps}
        {...resolvers}
    />;

    return (
        <EntryPageTemplate
            applicationName={applicationDetails.applicationName}
            applicationLogo={applicationDetails.applicationLogo}
            contentToRender={renderedContentFromMetadata}
        />
    );
}

EntryPage.propTypes = {
    location: PropTypes.shape({
        state: PropTypes.shape({})
    })
};

EntryPage.defaultProps = {
    location: {}
};

export default EntryPage;
